import config from '../../utils/config';

import chatDataCenter from "../chatDataCenter";
import Protocal from "./Protocal";
import ProtocalType_S2C from "./ProtocalType_S2C";
import ProtocalType_C2S from "./ProtocalType_C2S";

/**
 * Created by NI on 2019/3/28.
 */
const Member_sdk = function (obj) {
    this._init_(obj);
};

Member_sdk.prototype = {
    constructor: Member_sdk,

    /**
     * 物理连接成功的回调函数
     */
    onConnect: function () {
        console.debug("物理连接创建成功...");
    },
    /**
     * 物理连接重连中回调函数
     */
    onConnecting:function () {
        console.debug("重连中...");
    },
    /**
     * 物理连接断开的回调函数
     */
    onDisconnect: function () {
        console.debug("物理连接已断开...");
    },
    /**
     * 物理连接被强制登出回调函数
     */
    onForceLoginOut:function () {

    },
    /**
     * 接收到服务器业务消息回调函数
     * @param protocal {Protocal}
     */
    onHandleProtoCal:function (protoCal) {
        console.warn("未实现onHandleProtoCal函数")
    },
    /**
     * 收到邀请评价回调
     * @param ctsSessionId
     * @param openEvaluateFlag 1:启用 2:禁用
     */
    onHandleEvaluateInvitation:function (sessionId) {
        console.warn("收到邀请评价==sessionId:"+sessionId );
    },
    /**
     * 收到邀请留言回调
     * @param ctsSessionId
     */
    onHandleLeaveMessageInvitation:function (sessionId) {
        console.warn("收到邀请留言==sessionId:"+sessionId );
    },
    /**
     * 会话被客服关闭or会话被系统自动关闭
     */
    onHandleSessionBeClosed:function () {
        console.warn("会话被客服关闭or会话被系统自动关闭")
    },
    /**
     * 消息被撤回回调
     * @param messageId
     */
    onHandleMessageRecall:function (messageId) {

    },
    /**
     * 会话被动发生改变回调事件
     * @param obj
     */
    onHandleSessionChange:function (obj) {

    },

    /**
     * 网络相关
     */
    _webSocket_url:config.webSocketUrl,

    _webSocket: null,
    readyState:WebSocket.CLOSED,
    connectTimeOut :5000,

    /**
     * 重连相关
     */
    is_need_connect_again : true,// 是否需要自动重连
    ref_connect_timeout : 3000,// 重连频率
    ref_connect_count : 0,// 重连计数器
    ref_connect_max_count : 2,// 最大重连次数

    /**
     * 心跳相关
     */
    h_is_need_heart : true,// 是否需要心跳服务
    h_timeout : 10000,// 心跳频率
    h_timeoutObj : null,// 心跳函数
    h_count : 0,// 心跳计数器
    h_max_count : 3,// 最大失败次数
    h_msg : "a",// 心跳包

    /**
     * qos质量保证相关
     */
    open_qos : false,

  /**
     * 关闭/重置心跳服务
     * @returns {Member_sdk}
     */
    heart_reset: function () {
        this.h_count = 0;
        if(this.h_timeoutObj){
            clearTimeout(this.h_timeoutObj);
        }
        return this;
    },

    /**
     * 开启心跳服务
     */
    heart_start: function(){
        if(this.h_is_need_heart){
            var self = this;
            this.h_timeoutObj = setInterval(function () {
                if(self.readyState === WebSocket.OPEN){
                    if(self.h_count === self.h_max_count){
                        console.log("心跳检测到已断开连接");
                        self._webSocket.close();
                        self.heart_reset();
                    }else{
                        try{
                            self.send(self.h_msg);
                        }catch (e){
                            console.error(e.name+":"+e.message);
                        }
                        self.h_count++;
                        console.log(self.h_count);
                    }
                }else{
                    self.heart_reset();
                }
            }, this.h_timeout);
        }
    },

    open :function () {
        if(this.readyState === WebSocket.CONNECTING || this.readyState === WebSocket.OPEN){
            return;
        }
        var self = this;
        this.readyState = WebSocket.CONNECTING;// 状态为重连
        this.ref_connect_count++;
        this._webSocket = new WebSocket(this._webSocket_url+"?customerChannelId="+chatDataCenter.customer.customerChannelId
            +"&companyId="+chatDataCenter.customer.companyId
            +"&thirdId="+chatDataCenter.customer.thirdId);
        this._webSocket.onopen = function (event) {
            console.log("websocket has open");
            self.readyState = WebSocket.OPEN;
            self.heart_reset().heart_start();
            self.ref_connect_count = 0;
        };
        this._webSocket.onclose = function (event) {
            console.log("websocket has closed=="+event.code);
            self.readyState = WebSocket.CLOSED;
            if(event.code === 3001){// 被主动关闭且不需要断线重连
                //下线
                return;
            }
            if(self.ref_connect_count >= self.ref_connect_max_count){
                self.ref_connect_count = 0;
                self.onDisconnect();
            }else{
                self.onConnecting();
                self.open();
            }
        };

        this._webSocket.onerror = function (event) {
            console.error(event.code);
        };

        this._webSocket.onmessage = function (event) {
            if(event && event.data){
                self.onMessage(event.data)
            }
        }
    },

    Chech_Iterval:5000,// Qos质量保证线程心跳间隔(单位:毫秒) 默认5000ms
    Message_Just$Now_Time:2000,// “刚刚”发出的消息阀值定义（单位：毫秒），默认2000毫秒
    MessageList: [], //存放发送的信息

    /**
     * 开启Qos质量保证服务
     */
    qos_start: function(){
        open_qos = true;
        var self = this;
        setInterval(function () {
            if(self.MessageList.length > 0){
                for(var i = 0; i < self.MessageList.length; i++){
                    if(self.MessageList[i].sendNum === 0){
                        if((new Date().getTime() - self.MessageList[i].sendTime) > 2000){
                            self.MessageList[i].sendNum++;
                            self._webSocket.send(self.MessageList[i].toString());
                        }
                    }else{
                        if(self.MessageList[i].failCallback){
                            try{
                                self.MessageList[i].failCallback();
                            }catch (e){
                                console.log(e);
                            }
                        }
                        self.MessageList.splice(i,1);
                    }
                }
            }
        }, this.Chech_Iterval);
    },

    /**
     * 初始化函数
     * @param obj
     * @returns {boolean}
     * @private
     */
    _init_: function (obj) {
        if (typeof obj === 'undefined' || !obj) {
            console.error("not found param");
            return false;
        }
        if (typeof obj.onConnect === "function") {
            this.onConnect = obj.onConnect;
        }
        if (typeof obj.onConnecting === "function") {
            this.onConnecting = obj.onConnecting;
        }
        if (typeof obj.onDisconnect === "function") {
            this.onDisconnect = obj.onDisconnect;
        }
        if(typeof obj.onHandleProtoCal === 'function'){
            this.onHandleProtoCal = obj.onHandleProtoCal;
        }
        if(typeof obj.onHandleEvaluateInvitation === 'function'){
            this.onHandleEvaluateInvitation = obj.onHandleEvaluateInvitation;
        }
        if(typeof obj.onHandleLeaveMessageInvitation === 'function'){
            this.onHandleLeaveMessageInvitation = obj.onHandleLeaveMessageInvitation;
        }
        if(typeof obj.onHandleSessionBeClosed === 'function'){
            this.onHandleSessionBeClosed = obj.onHandleSessionBeClosed;
        }
        if(typeof obj.onHandleMessageRecall === 'function'){
            this.onHandleMessageRecall = obj.onHandleMessageRecall;
        }
        if(typeof obj.onHandleSessionChange === 'function'){
            this.onHandleSessionChange = obj.onHandleSessionChange;
        }
        if(typeof obj.onForceLoginOut == 'function'){
            this.onForceLoginOut = obj.onForceLoginOut;
        }
        this.open()
    },

    /**
     * 通知客户端信息
     */
    onMessage: function (_msg) {
        if(typeof _msg === 'undefined' || !_msg || _msg === ''){
            return;
        }
        this.h_count = 0;

        if(_msg === 'a'){
            return;
        }
        console.log("receive==>"+_msg);
        var protoCal = new Protocal(JSON.parse(_msg));
        if(typeof protoCal === 'undefined' || protoCal === null){
            return;
        }
        if(protoCal.qos){
            var message = {
                fp:protoCal.fp
            };
            this.send(new Protocal({
              msgType:ProtocalType_C2S.ACK,
              messageContent: JSON.stringify(message)
            }).toString());
        }

        if(protoCal.msgType === ProtocalType_S2C.ACK){
            this.handle_ACK(protoCal);
            return;
        }
        if(protoCal.msgType === ProtocalType_S2C.AUTH){
            this.handle_AUTH(protoCal);
            this.onConnect();
            return;
        }
        if(protoCal.msgType == ProtocalType_S2C.FORCE_LOGIN_OUT_C){
            this.closeWebSocket();
            this.onForceLoginOut();
            return;
        }
        this.onHandleProtoCal(protoCal);
    },

    /**
     * 通知更新顾客所在IM服务器
     * @param obj 消息体
     */
    handle_AUTH:function (protocal) {
        var auth = JSON.parse(protocal.messageContent);
        chatDataCenter.customer.setSourceIp(auth.ip)
    },

    /**
     * 通知顾客应答包
     * @param ack 消息体
     */
    handle_ACK:function(protocal){
        var ack = JSON.parse(protocal.messageContent);
        var messageId = ack.messageId;
        for(var i = 0; i < this.MessageList.length; i++){
            if(this.MessageList[i].messageId === messageId){
                if(this.MessageList[i].successCallback){
                    try {
                        if(typeof this.MessageList[i].res !== 'undefined' && this.MessageList[i].res != null){
                            this.MessageList[i].successCallback(this.MessageList[i].res);
                        }else{
                            this.MessageList[i].successCallback();
                        }
                    }catch (e){

                    }
                }
                this.MessageList.splice(i,1);
                break;
            }
        }
    },

    ACK_Response:function (messageId) {
        if(typeof messageId !== 'undefined' && messageId !== null && messageId !== ''){
            var data = {
                messageId : messageId
            };
            var protocal = new Protocal({
                msgType:ProtocalType_C2S.ACK,
                messageContent:JSON.stringify(data)
            });
            this.send(protocal.toString());
        }
    },

    /**
     * 消息已读通知服务器
     * @param id 消息的id
     * @param sessionId 消息的sessionId
     * @param messageId 消息的messageId
     * @constructor
     */
    MBR_Response:function (id,sessionId, messageId) {
        if(typeof id !== 'undefined' && id !== null && id !== ''){
            var data = {
                id : id,
                sessionId : sessionId,
                messageId : messageId,
            };
            var protocal = new Protocal({
                msgType:ProtocalType_C2S.MBR,
                messageContent:JSON.stringify(data)
            });
            this.send(protocal.toString());
        }
    },

    /**
     * 消息全部已读通知服务器
     * @param id 消息的id
     * @param sessionId 消息的sessionId
     * @param messageId 消息的messageId
     * @constructor
     */
    MBRA_Response:function (sessionId) {
        var data = {
            sessionId:sessionId,
            customerChannelId : chatDataCenter.customer.customerChannelId,
            messageDirection : 'U'
        };
        var protocal = new Protocal({
            msgType:ProtocalType_C2S.MBRA,
            messageContent:JSON.stringify(data)
        });
        this.send(protocal.toString());
    },

    /**
     * 发送聊天消息(内部函数,不对外提供sdk)
     * @param message 消息
     * @param successCallback 发送成功回调函数
     * @param failCallback 发送失败回调函数
     * @param readCallback 消息被对方已读回调函数
     */
    sendMessage: function (message, successCallback, failCallback, readCallback) {
        if(this._webSocket && this.readyState === WebSocket.OPEN){
            if(this.open_qos){
                message.successCallback = successCallback;
                message.failCallback = failCallback;
                this.MessageList.push(message);
            }

            var protocal = new Protocal({
                msgType:ProtocalType_C2S.MC,
                messageContent: message.toString()
            });
            this.send(protocal.toString());
        }else{
            if(failCallback){
                failCallback();
            }
        }
    },

    /**
     * 发送消息
     */
    send:function (message) {
        if(message !== "a"){
            console.log("send<=="+message);
        }
        this._webSocket.send(message);
    },
    /**
     * 物理连接断开后主动重连
     */
    reConnect:function () {
        this.open();
    },

    closeWebSocket:function () {
        this._webSocket.close(3001);
    }

};

export default Member_sdk;
